export const API_MONTHWISE_CONV_UNCONV_LEADS_SUCCESS =
  "API_TOTAL_TRADE_ACCOUNT_SUCCESS";
export const API_MONTHWISE_CONV_UNCONV_LEADS_FAIL =
  "API_MONTHWISE_CONV_UNCONV_LEADS_FAIL";
export const GET_MONTHWISE_CONV_UNCONV_LEADS =
  "GET_MONTHWISE_CONV_UNCONV_LEADS";
  export const START_LOADING = "START_LOADING";
  export const STOP_LOADING = "STOP_LOADING";
  export const RESET_MONTHWISE_LEADS = "RESET_MONTHWISE_LEADS";
